/* eslint-disable no-bitwise */

export function lerpColor(a: number, b: number, amount: number): number {
  const ar = a >> 16;
  const ag = (a >> 8) & 0xff;
  const ab = a & 0xff;

  const br = b >> 16;
  const bg = (b >> 8) & 0xff;
  const bb = b & 0xff;

  const rr = ar + amount * (br - ar);
  const rg = ag + amount * (bg - ag);
  const rb = ab + amount * (bb - ab);

  return (rr << 16) + (rg << 8) + (rb | 0);
}
